export const inlineListMaxLength = 2_000
export const defaultValue = '<empty>'

export const defaultHeaderName = 'Name'
export const defaultHeaderValue = 'Value Used by the Build'
